(function () {
	'use strict';

	angular
		.module('uwAgenda.settings.grouppractice')
		.controller('LocationDetailController', LocationDetailControllerFn);
	
	LocationDetailControllerFn.$inject = [
        'location',
        'Alert', 
        'GroupPracticeService',
		'SharedAgendaService',
        'ItemTableService', 
        '$uibModalInstance',
		'$translate'];

	function LocationDetailControllerFn(
        location,
        Alert, 
        GroupPracticeService,
		SharedAgendaService,
        ItemTableService, 
        $uibModalInstance,
		$translate
    ) {
		var vm = this;
		
		vm.location = location;
		vm.waitingRooms = [];

		activate();

		function activate() {
			var groupPracticeId = SharedAgendaService.currentUser().groupPracticeId;
			GroupPracticeService.getWaitingRooms(groupPracticeId)
								.then(function(waitingRooms) {
									vm.waitingRooms = waitingRooms;

									// new location -> take first waitingroom in the list
									var firstWaitingRoom = vm.waitingRooms[0];
									if (firstWaitingRoom &&
										!vm.location.waitingRoomId) {
										vm.location.waitingRoomId = firstWaitingRoom.id;
										vm.location.waitingRoomName = firstWaitingRoom.name;
									}
								});
		}

		vm.selectWaitingRoom = function(waitingRoom) {
			vm.location.waitingRoomId = waitingRoom.id;
			vm.location.waitingRoomName = waitingRoom.name;
		}

		vm.save = function () {
			
			// save or update
			if (vm.location.id > 0) {
				// update
				GroupPracticeService.updateInternalLocation(
						vm.location.groupPracticeId, 
						vm.location.id,
						vm.location
					).then(function() {
						Alert.success($translate.instant('internal_location_updated'));
						$uibModalInstance.close();
					});				
			} 
			else {
				// save
				GroupPracticeService.createInternalLocation(
					vm.location.groupPracticeId, 
					vm.location
				).then(function() {
					Alert.success($translate.instant('internal_location_created'));
					$uibModalInstance.close();
				});				
			}
		};

		// close modal
		vm.abort = function () {
			$uibModalInstance.dismiss();
		};	
	}
})();
